WB.Pollers = WB.Services || {};
WB.Pollers.WeatherPollerManager = function($interval, $rootScope, $log, _Config, WeatherPoller) {

    this.types = Object.keys(_Config.PollingTimes);
    this.weatherPollers = [];
    this.intervals = {};

    this.RegisterPoller = function(type) {
        if (!_Config.PollingTimes[type]) {
            throw new Error('Poller doesn\'t exist.');
            return;
        }

        var time = parseInt(_Config.PollingTimes[type]);
        if (!this.intervals[type]) {
            $log.debug('New interval created for [%s].', type);
            var _this = this;
            this.intervals[type] = $interval(function() {
                _this.PollersOfType(type).forEach(function(poller) { poller.poll(); });
            }, time * 1000);
        }

        var newPoller = new WeatherPoller({
            type: type,
            time: time,
            $interval: this.intervals[type],
            manager: this
        });

        this.weatherPollers.push(newPoller);

        return newPoller;
    };

    this.DeregisterPoller = function(poller) {
        var weatherPollerIndex = this.weatherPollers.indexOf(poller);
        this.weatherPollers.splice(weatherPollerIndex, 1);

        var pollersOfType = this.PollersOfType(poller.type);

        if (pollersOfType.length === 0) {
            $log.debug('Removing interval for [%s].', poller.type);
            var interval = this.intervals[poller.type];
            $interval.cancel(interval);
            delete this.intervals[poller.type];
        }
    };

    this.PollersOfType = function(type) {
        return this.weatherPollers.filter(function(poller) {
            return poller.type === type;
        });
    };

};
WB.Pollers.WeatherPollerManager.$inject = ['$interval', '$rootScope', '$log', '_Config', 'WeatherPoller'];

WB.Core.service('WeatherPollerManager', WB.Pollers.WeatherPollerManager);
